import React from 'react';
import {connect} from 'react-redux';
import Grid from "@material-ui/core/Grid";
import {Button} from "@blueprintjs/core";
import {deliverySetStorageFilter} from "../../Actions/DeliveryActions";
import DeliveryStorageFiltersNorth from "./DeliveryStorageFiltersNorth";
import DeliveryStorageFiltersSouth from "./DeliveryStorageFiltersSouth";

class DeliveryStorageFilters extends React.PureComponent {

  handleStorageFilter = (storageFilter) => () => {
    this.props.dispatch(deliverySetStorageFilter(storageFilter));
  };

  render() {
    const {storageFilter, executingStorage, location} = this.props;

    let defaultStorage = storageFilter;
    if ( location === "tukwila" ) {
      if ( !defaultStorage || defaultStorage === "Exterior" ) defaultStorage = "Windows";
      return (
        <DeliveryStorageFiltersSouth
          onClick={this.handleStorageFilter}
          executingStorage={executingStorage}
          storageFilter={defaultStorage}
        />
      )
    } else {
      return (
        <DeliveryStorageFiltersNorth
          onClick={this.handleStorageFilter}
          executingStorage={executingStorage}
          storageFilter={defaultStorage}
        />
      );
    }
  }
}

function mapStateToProps(state) {
  const selectedDeliveryId = state.DeliveryReducer.selectedDelivery;
  return {
    location: state.DeliveryReducer.deliveries[selectedDeliveryId].location,
    storageFilter: state.DeliveryReducer.storageFilter,
    executingStorage: state.DeliveryReducer.executingStorage,
  };
}

export default connect(mapStateToProps)(DeliveryStorageFilters);